import "./footer.css"
import { useState, useEffect } from "react";

const LINKS = [
    { label: "LinkedIn", url: "https://www.linkedin.com/in/mohammed-swalih-a560951ba/" },
    { label: "Instagram", url: "https://www.instagram.com/itsme_swalih/?hl=en" },
    { label: "Email", url: "mailto:swalih3409@gmail.com" },
];

export default function Footer() {
    const [clock, setClock] = useState("");
    const [weather, setWeather] = useState(null);

    useEffect(() => {
        const tick = () => {
            setClock(new Date().toLocaleTimeString("en-US", {
                hour: "2-digit", minute: "2-digit", second: "2-digit",
            }));
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, []);

    useEffect(() => {
        // Free, no-key weather for Kottayam, IN. Fails silently.
        fetch("https://api.open-meteo.com/v1/forecast?latitude=9.5916&longitude=76.5222&current=temperature_2m")
            .then((r) => r.json())
            .then((d) => {
                const t = d?.current?.temperature_2m;
                if (typeof t === "number") setWeather(`${Math.round(t)}°C`);
            })
            .catch(() => {});
    }, []);

    return (
        <footer className="footer2">
            <p className="footStatement">
                Just a mark of my existence in the <span className="mute">vastness of the web.</span>
            </p>

            <div className="footLinks">
                {LINKS.map((l) => (
                    <a key={l.label} className="footLink"
                        href={l.url}
                        target={l.url.startsWith("mailto") ? undefined : "_blank"}
                        rel="noreferrer">
                        <span>{l.label}</span>
                        <span className="footLinkArrow">↗</span>
                    </a>
                ))}
            </div>

            <div className="footBar">
                <span>© {new Date().getFullYear()} Mohammed Swalih</span>
                <span className="footMeta">
                    {clock}
                    <br />
                    Kottayam, India{weather ? ` · ${weather}` : ""}
                </span>
            </div>
        </footer>
    )
}
